export const communicationRfe = {
	pack: {
		intro: "Pour accéder aux fonctionnalités de facturation électronique, la souscription au Pack RFE est obligatoire.",
		monthly: "Dans le cadre de votre abonnement mensuel, le Pack RFE est facturé 4,80 € par mois.",
		annual: "Dans le cadre de votre abonnement annuel, le Pack RFE est facturé 57,60 € par an.",
		'start-date': "Le Pack RFE entrera en vigueur à compter du 01/09/2026.",
		prorata: "Pour votre abonnement annuel, un prorata de {0} sera ajouté à votre prochaine facture, correspondant à la période du {1} jusqu'à la fin de votre abonnement actuel qui prend fin le {2}."
	},
	substitutes: {
		title: "Inclure vos remplaçants ?",
		'subtitle-annual': "Étape facultative. Chaque remplaçant activé : {0} pour la période du {1} au {2}, puis {3}/an.",
		'subtitle-monthly': "Étape facultative. Chaque remplaçant activé : {0} par mois.",
		'select-all': "tout sélectionner",
		'unselect-all': "tout désélectionner",
		'selected-count': "{count} remplaçant sélectionné | {count} remplaçants sélectionnés",
		'row-note-annual': "prorata",
		'row-note-monthly': "par mois",
		'incomplete-profile': "Profil incomplet",
		'incomplete-profile-title': "Le SIREN, le n° de TVA ou le code NAF de ce remplaçant sont manquants."
	},
	choice: {
		accept: "J’accepte et reconnais avoir lu et accepté {0}.",
		refuse: "Je refuse",
		link: "les CGU B2BRouter",
		link_title: "Les conditions générales d'utilisation B2BRouter"
	},
	'refuse-reason': {
		label: "Pouvez-vous préciser le motif de votre refus ?",
		placeholder: "Précisez ici...",
		title: "",
		'maxLength-warning': "Attention : le texte ne peut pas dépasser {0} caractères."
	},
	stepper: {
		platform: "Plateforme",
		substitutes: "Remplaçants",
		recap: "Récapitulatif"
	},
	nav: {
		next: "continuer",
		back: "retour"
	},
	recap: {
		'accept-title': "Récapitulatif & confirmation",
		'accept-subtitle': "Vérifiez l'impact exact sur votre facturation avant de confirmer.",
		'refuse-title': "Confirmer votre refus",
		'refuse-warning': "Sans notre plateforme agréée partenaire B2BRouter, vous ne pourrez pas ni émettre, ni recevoir vos factures électroniques via Osteo2ls. Vous pouvez revenir sur votre choix dans vos paramètres Osteo2ls.",
		'start-pill': "Facturé au {0}",
		'line-holder': "Pack RFE · Titulaire",
		'line-holder-sub': "{0} · vous",
		'line-mandatory': "obligatoire",
		'line-substitute': "Pack RFE · {0}",
		'line-substitute-role': "Remplaçant",
		'line-remove': "retirer",
		'next-invoice': "Sur votre prochaine facture",
		'next-invoice-detail-annual': "Prorata jusqu'au {0} (fin de l'abonnement actuel) · {1}",
		'next-invoice-detail-monthly': "{0}",
		'recurring-annual': "Puis chaque année",
		'recurring-monthly': "Puis chaque mois",
		'monthly-line': "Chaque mois",
		'packs-count': "{count} Pack RFE | {count} Packs RFE",
		'foot-next-invoice': "Prochaine facture · {0}",
		'no-amount': "Aucun montant ajouté",
		'confirm-accept': "confirmer et activer le pack RFE",
		'confirm-refuse': "confirmer mon refus",
		'subscription-note': "Les montants des Packs RFE souscrits s'ajoutent à votre abonnement actuel. Le montant total facturé correspondra donc au prix de votre abonnement, auquel s'ajoute celui des Packs RFE."
	}
}
